module.exports = __webpack_public_path__ + "static/media/averta-light.0f236789.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/averta-light.woff2
// module id = 847
// module chunks = 4